/**
 * ServiceContext
 *
 * React context for service-layer dependency injection.
 * Provides access to domain services throughout the component tree.
 *
 * Services are added incrementally as each domain migrates to the
 * service-level architecture. The context value starts empty and grows
 * as services are registered in ServiceProvider.
 */
import { createContext } from 'react';
import type { ServiceRegistry } from '../services/types';

export const ServiceContext = createContext<ServiceRegistry>({});
